module.exports = __webpack_public_path__ + "img/RCUNI.3e4769ed.svg";